var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.history") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      { staticClass: "requestsList" },
                      [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-start" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "mb-5",
                                attrs: { cols: "4", lg: "2", xl: "2" },
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btnFilter",
                                    on: {
                                      click: function ($event) {
                                        _vm.displayFilter = !_vm.displayFilter
                                      },
                                    },
                                  },
                                  [
                                    _vm.displayFilter
                                      ? _c("i", {
                                          staticClass: "fa-light fa-minus",
                                        })
                                      : _c("i", {
                                          staticClass: "fa-light fa-plus",
                                        }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("filter.fltr")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "mb-5",
                                attrs: { cols: "4", lg: "2", xl: "2" },
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btnFilter btn-secondary",
                                    on: { click: _vm.refreshInbox },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-rotate-right",
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.rfrsh")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "mb-5",
                                attrs: { cols: "4", lg: "2", xl: "2" },
                              },
                              [
                                _vm.inboxMessages.length > 0
                                  ? _c(
                                      "b-button",
                                      { on: { click: _vm.extractCSV } },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-light fa-upload fs-14px",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "fab-label" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("common.extract"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.displayFilter
                          ? _c(
                              "b-row",
                              { staticClass: "min-w-100" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "filter-item-action mb-5",
                                    attrs: { sm: "6", lg: "3", cols: "12" },
                                  },
                                  [
                                    _c("datetime-picker-custom", {
                                      staticClass: "z-1",
                                      class: {
                                        "filter-item-input": true,
                                        "filter-item-input-complete":
                                          _vm.dateBegin,
                                      },
                                      attrs: {
                                        format: "DD/MM/YYYY H:i:s",
                                        inputLabel: _vm.$t(
                                          "common.date_start_label"
                                        ),
                                        customInputParentClass:
                                          "filter-item-content",
                                        customInputClass: "w-100",
                                        maxLength: 19,
                                        placeholderValue: _vm.$t(
                                          "common.datetime_picker_empty_date"
                                        ),
                                        inputIcon: "fa-solid fa-calendar",
                                      },
                                      model: {
                                        value: _vm.dateBegin,
                                        callback: function ($$v) {
                                          _vm.dateBegin = $$v
                                        },
                                        expression: "dateBegin",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "filter-item-action mb-5",
                                    attrs: { sm: "6", lg: "3", cols: "12" },
                                  },
                                  [
                                    _c("datetime-picker-custom", {
                                      staticClass: "z-1",
                                      class: {
                                        "filter-item-input": true,
                                        "filter-item-input-complete":
                                          _vm.dateEnd,
                                      },
                                      attrs: {
                                        format: "DD/MM/YYYY H:i:s",
                                        inputLabel: _vm.$t(
                                          "common.date_end_label"
                                        ),
                                        customInputParentClass:
                                          "filter-item-content",
                                        customInputClass: "w-100",
                                        maxLength: 19,
                                        placeholderValue: _vm.$t(
                                          "common.datetime_picker_empty_date"
                                        ),
                                        inputIcon: "fa-solid fa-calendar",
                                      },
                                      model: {
                                        value: _vm.dateEnd,
                                        callback: function ($$v) {
                                          _vm.dateEnd = $$v
                                        },
                                        expression: "dateEnd",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "filter-item-action mb-5",
                                    attrs: { sm: "6", lg: "3", cols: "12" },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "filter-item-title",
                                        attrs: { for: "action-login" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("administration.identifier")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "filter-item-content" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.login,
                                              expression: "login",
                                            },
                                          ],
                                          class: {
                                            "filter-item-input": true,
                                            "filter-item-input-complete":
                                              _vm.login,
                                          },
                                          attrs: {
                                            id: "action-login",
                                            type: "text",
                                            placeholder: _vm.$t(
                                              "administration.identifier"
                                            ),
                                          },
                                          domProps: { value: _vm.login },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.login = $event.target.value
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "filter-item-action mb-5",
                                    attrs: { sm: "6", lg: "3", cols: "12" },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "filter-item-title",
                                        attrs: { for: "action-user" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("administration.user_name")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "filter-item-content" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.user,
                                              expression: "user",
                                            },
                                          ],
                                          class: {
                                            "filter-item-input": true,
                                            "filter-item-input-complete":
                                              _vm.user,
                                          },
                                          attrs: {
                                            id: "action-user",
                                            type: "text",
                                            placeholder: _vm.$t(
                                              "administration.user_name"
                                            ),
                                          },
                                          domProps: { value: _vm.user },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.user = $event.target.value
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "filter-item-action mb-5",
                                    attrs: { sm: "6", lg: "3", cols: "12" },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "action-type" } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("common.action_type")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.actionType,
                                            expression: "actionType",
                                          },
                                        ],
                                        staticClass:
                                          "filter-item-content min-w-100",
                                        staticStyle: { padding: "0.5rem" },
                                        attrs: { id: "select-action-type" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.actionType = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { value: "", disabled: "" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("history.slct_actn")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.actionList,
                                          function (label, type) {
                                            return _c(
                                              "option",
                                              {
                                                key: type,
                                                attrs: { title: label },
                                                domProps: { value: type },
                                              },
                                              [_vm._v(_vm._s(label))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "d-flex flex-row-reverse mt-4",
                                    attrs: { lg: "3", cols: "12" },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { size: "sm" },
                                        on: { click: _vm.applyFilter },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("common.srch")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mr-3",
                                        attrs: {
                                          size: "sm",
                                          disabled: !_vm.hasInputFilter,
                                        },
                                        on: { click: _vm.clearFilterFields },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("filter.clr_fltr_field")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "min-w-100" },
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12", lg: "12", cols: "12" } },
                              [
                                _vm.activateSpinner
                                  ? _c("spinner")
                                  : _c(
                                      "div",
                                      { staticClass: "w-100" },
                                      [
                                        _vm.inboxMessages.length
                                          ? _c("b-table", {
                                              key: _vm.resetHisto,
                                              staticClass:
                                                "table mt-3 text-center table-striped",
                                              attrs: {
                                                responsive: "",
                                                hover: "",
                                                borderless: "",
                                                outlined: "",
                                                items: _vm.inboxMessages,
                                                fields: _vm.historyFields,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "cell(dateAction)",
                                                    fn: function (data) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cursor text-ellipsis",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getDate(
                                                                    data.value
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(name)",
                                                    fn: function (data) {
                                                      return [
                                                        !data.value
                                                          ? _c("div", [
                                                              _vm._v("-"),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.value
                                                                )
                                                              ),
                                                            ]),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(label)",
                                                    fn: function (data) {
                                                      return [
                                                        !_vm.translateDetails(
                                                          data.item.details,
                                                          data.item
                                                        ).length
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.value
                                                                )
                                                              ),
                                                            ])
                                                          : _c(
                                                              "f7-accordion-item",
                                                              {
                                                                staticClass:
                                                                  "accordionForm",
                                                                attrs: {
                                                                  expanded:
                                                                    data.item
                                                                      .open,
                                                                },
                                                                on: {
                                                                  "accordion:open":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      data.item.open = true
                                                                    },
                                                                  "accordion:opened":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      data.item.openFinished = true
                                                                      _vm.resetHisto =
                                                                        !_vm.resetHisto
                                                                    },
                                                                  "accordion:close":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      data.item.open =
                                                                        data.item.open = false
                                                                    },
                                                                  "accordion:closed":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      data.item.openFinished = false
                                                                      _vm.resetHisto =
                                                                        !_vm.resetHisto
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "f7-accordion-toggle",
                                                                  {
                                                                    staticClass:
                                                                      "accordionToggle",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form-group row justify-content-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "col-sm-auto",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  data.value
                                                                                ) +
                                                                                "\n                              "
                                                                            ),
                                                                            data
                                                                              .item
                                                                              .open ===
                                                                            true
                                                                              ? _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ml-1 mt-1 fa-light fa-chevron-down color-var-actionButtonColorBlue",
                                                                                  }
                                                                                )
                                                                              : _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ml-1 fa-light fa-chevron-right color-var-actionButtonColorBlue",
                                                                                  }
                                                                                ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "f7-accordion-content",
                                                                  {
                                                                    class: {
                                                                      accordionContentExpended:
                                                                        data
                                                                          .item
                                                                          .openFinished,
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    _vm.translateDetails(
                                                                      data.item
                                                                        .details,
                                                                      data.item
                                                                    ),
                                                                    function (
                                                                      detail,
                                                                      index
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: index,
                                                                        },
                                                                        [
                                                                          _vm.isRTPAction(
                                                                            data.item
                                                                          )
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "cursor",
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.detailsRTP(
                                                                                          data.item
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "u",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                          " +
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "history.rtp_details"
                                                                                            )
                                                                                          )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "span",
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _c(
                                                                                        "b",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              detail.name
                                                                                            ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  detail.old
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              detail.old
                                                                                            ) +
                                                                                              " "
                                                                                          ),
                                                                                          _c(
                                                                                            "b",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "→"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          detail.value
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2206871754
                                              ),
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center mt-5",
                                              },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("common.no_result")
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.activateSpinner
                ? _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("cm-pagination", {
                            attrs: {
                              maxResultsByPage: _vm.paginationObject.maxResults,
                              firstIndex: _vm.paginationObject.firstIndex,
                              nbResultsTotal:
                                _vm.paginationObject.nbResultsTotal,
                              refreshEvent: _vm.paginationObject.refresh,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }